import { create } from "zustand";
import { FilterSearchPayload } from "@/app/home/components/table/DataTable";

type SavedFilterState = {
    savedFilter: Map<string, Map<string, FilterSearchPayload>>
    setPageFilter: (path: string, filter: Map<string, FilterSearchPayload>) => void;
}

export const useSavedFilters = create<SavedFilterState>(
        (set) => ({
            savedFilter: new Map(),
            setPageFilter: (path, filter) => {
                set(state => {
                    state.savedFilter.set(path, filter);
                    return { savedFilter: new Map(state.savedFilter) }
                })
            }
        })
)
